export function Field({ label, error, children, required, testId }) {
    return (
        <div className="space-y-1.5" data-testid={testId}>
            <label className="field-label flex items-center gap-1.5">
                {label}
                {required && <span className="text-[#D4AF37] normal-case tracking-normal">*</span>}
            </label>
            {children}
            {error && (
                <p className="text-xs text-red-400/90 font-sans" data-testid={`${testId}-error`}>
                    {error}
                </p>
            )}
        </div>
    );
}

export function TextInput({ value, onChange, placeholder, type = "text", testId, autoComplete, inputMode, maxLength }) {
    return (
        <input
            type={type}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="glow-input w-full px-4 py-3 rounded-xl text-sm"
            data-testid={testId}
            autoComplete={autoComplete}
            inputMode={inputMode}
            maxLength={maxLength}
        />
    );
}
